export const BILLING_CYCLE_INVOICES_DEFAULT_PAGE_SIZE = 10;
